/*
 * @Author: Src
 * @Date: 2025-07-21 09:25:04
 * @LastEditTime: 2025-11-26 09:17:42
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/carRouter/carOrderRoutes.ts
 * @Description: 头部注释配置模板
 */
import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';

import OrderBList from '@/views/carModule/order/order_bList.vue';
import OrderBListNotPay from '@/views/carModule/order/order_bListnotpay.vue';
import CarPaymentVoucherManagement from '@/views/carModule/order/CarPaymentVoucherManagement.vue';
import AutomaticSettlementlist from '@/views/carModule/order/AutomaticSettlementlist.vue';
import BOrderStatementDetails from '@/views/carModule/order/BOrderStatementDetails.vue';
import BRefundList from '@/views/carModule/order/BRefundList.vue';

import { AuthEnum } from '@/services/permission.service';

const carOrderRoutes: RouteConfig = {
  path: '/carorder',
  component: Main,
  redirect: {
    name: ' carorder.index',
  },
  meta: {
    title: '订单管理',
  },
  children: [
    {
      name: 'carorder.index',
      path: '/carorder/list',
      component: OrderBList,
      props: {
        routeType: 'usedCar',
        auth: [AuthEnum.二手车B端订单列表],
      },
      meta: {
        title: '订单列表',
      },
    },
    {
      name: 'carorder.notpay',
      path: '/carorder/notpay',
      component: OrderBListNotPay,
      props: {
        routeType: 'usedCar',
        auth: [AuthEnum.二手车B端订单列表],
      },
      meta: {
        title: '待付款订单',
      },
    },
    {
      name: 'carorder.voucher',
      path: '/carorder/voucher',
      component: CarPaymentVoucherManagement,
      props: {
        routeType: 'usedCar',
        auth: [AuthEnum.二手车收款凭证管理],
      },
      meta: {
        title: '收款凭证管理',
      },
    },
    {
      name: 'carorder.settlement',
      path: '/carorder/settlement',
      component: AutomaticSettlementlist,
      props: {
        routeType: 'usedCar',
        auth: [AuthEnum.二手车B端自动结算明细],
      },
      meta: {
        title: '自动结算列表',
      },
    },
    {
      name: 'carorder.d_refund',
      path: '/carorder/d_refund',
      component: BRefundList,
      props: {
        routeType: 'usedCar',
        auth: [AuthEnum.二手车B端退单列表],
      },
      meta: {
        title: '退款申请列表',
      },
    },
    {
      name: 'carorder.statement',
      path: '/carorder/statement/:billId',
      component: BOrderStatementDetails,
      props: {
        routeType: 'usedCar',
        auth: [AuthEnum.二手车B端退单列表],
      },
      meta: {
        title: '订单详情',
      },
    },
  ],
};

export default carOrderRoutes;
